import { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { Card } from 'components/Library'
import { colors } from 'components/Library/theme'
import { useSelector } from 'react-redux'

const UserActions = () => {
  const { pageAnalytics } = useSelector((state) => state.analytics)

  const [datosGrafico, setDatosGrafico] = useState([])

  const obtenerNombreAccion = (accion) => {
    if (accion === 'main') return 'Botón principal'
    if (accion === 'footer') return 'Botón footer'
    if (accion === 'beneficios-0') return 'Botón beneficios 1'
    if (accion === 'beneficios-1') return 'Botón beneficios 2'
    if (accion === 'beneficios-2') return 'Botón beneficios 3'
  }

  useEffect(() => {
    if (pageAnalytics[4] && pageAnalytics[4].rowCount > 0) {
      const datos = []
      pageAnalytics[4].rows.forEach((analytic) => {
        // Obtener los valores de la iteración actual
        const accion = analytic.dimensionValues[0].value // customEvent:tipo_cta
        const valor = analytic.metricValues[0].value // eventCount

        if (accion && accion !== '(not set)') {
          datos.push({
            x: obtenerNombreAccion(accion),
            y: parseInt(valor)
          })
        }
      })
      setDatosGrafico(datos)
    }
  }, [pageAnalytics])

  return (
    <Card style={{ padding: '2rem', width: '100%' }}>
      <Chart
        style={{ width: '100%' }}
        options={{
          chart: {
            type: 'treemap',
            toolbar: {
              show: false
            }
          },
          title: {
            text: 'Acciones de usuarios'
          },
          colors: [colors.primary, colors.secondary, colors.tertiary]
        }}
        height={250}
        series={[
          {
            data: datosGrafico
          }
        ]}
        type="treemap"
      />
    </Card>
  )
}

export default UserActions
